import React, { ReactNode, useCallback, useState } from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { HelpModal } from './HelpModal';
import { useHelpWidget } from './useHelpWidget';
import { ExperimentSpec } from '../../../constants/ExperimentSpec';

interface IUseHelpLink {
  helpModalComponent: ReactNode;
  onHelpClick(event): void;
}

export const useHelpLink = (articleFromProps: string): IUseHelpLink => {
  const [article, setArticle] = useState(null);
  const { openHelpWidgetArticle } = useHelpWidget();
  const { experiments } = useExperiments();
  const isNewHelpWidgetEnabled = experiments.enabled(ExperimentSpec.UseNewHelpWidget);
  const openHelpModal = useCallback(
    (event) => {
      if (isNewHelpWidgetEnabled && window.WixSupportChatSDK) {
        openHelpWidgetArticle(articleFromProps);
      } else {
        setArticle(articleFromProps);
      }
      event.stopPropagation();
    },
    [articleFromProps, isNewHelpWidgetEnabled, openHelpWidgetArticle],
  );

  const closeHelpModal = useCallback(() => setArticle(null), []);

  return {
    helpModalComponent: <HelpModal article={article} onClose={closeHelpModal} />,
    onHelpClick: openHelpModal,
  };
};
